import { ISuite } from './suite';

export interface IEmergencyContacts {
    name: string;
    email: string;
    phone: string;
    relation: string;
    note: string;
    isPrimary: boolean;
    suite: number | ISuite; // TODO: remove ISuite type after bug fixes
    user: number;
}

export class EmergencyContacts implements IEmergencyContacts {
    email = '';
    isPrimary = false;
    name = '';
    note = '';
    phone = '';
    relation = '';
    suite: number;
    user: number;

    constructor(contact: Partial<IEmergencyContacts> = {}) {
        Object.assign(this, contact);
    }

}



// WEBPACK FOOTER //
// /app/src/app/types/api-response/building/emergency-contacts.ts